"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroupedOptions = exports.parseKey = exports.getKey = exports.sortMatrixAttributeValues = exports.DisplayTableOption = exports.CellType = void 0;
exports.getCellType = getCellType;
exports.formatValue = formatValue;
const attributes_1 = require("../../constants/attributes");
var CellType;
(function (CellType) {
    CellType["AttributeHeaderCell"] = "ATTRIBUTE_HEADER_CELL";
    CellType["AttributeHeaderSummaryCell"] = "ATTRIBUTE_HEADER_SUMMARY_CELL";
    CellType["AttributeValueCell"] = "ATTRIBUTE_VALUE_CELL";
    CellType["RegularCell"] = "REGULAR_CELL";
})(CellType || (exports.CellType = CellType = {}));
var DisplayTableOption;
(function (DisplayTableOption) {
    DisplayTableOption["HideEmptyColumns"] = "HIDE_EMPTY_COLUMNS";
    DisplayTableOption["HideEmptyRows"] = "HIDE_EMPTY_ROWS";
})(DisplayTableOption || (exports.DisplayTableOption = DisplayTableOption = {}));
function getCellType({ field, isSelectedAttributeRow, rowIndex }) {
    // 1) this is our attribute cell
    if (isSelectedAttributeRow && field === 'value') {
        return CellType.AttributeHeaderCell;
    }
    // 2) this is our topTotalCount attribute cell
    if (isSelectedAttributeRow && field !== 'value') {
        return CellType.AttributeHeaderSummaryCell;
    }
    // 3)  this is our attribute-value cell
    if (rowIndex > 0 && field === 'value') {
        return CellType.AttributeValueCell;
    }
    // 4) just regular cell
    return CellType.RegularCell;
}
function formatValue(value) {
    return value === 0 ? '-' : value;
}
const TRAILING_ATTRIBUTE_VALUE_ORDER = [
    attributes_1.SpecialAttributeValue.NotApplicable,
    attributes_1.SpecialAttributeValue.Unknown,
];
const sortMatrixAttributeValues = (rows) => [...rows].sort((first, second) => {
    const firstSpecialIndex = TRAILING_ATTRIBUTE_VALUE_ORDER.indexOf(first.value);
    const secondSpecialIndex = TRAILING_ATTRIBUTE_VALUE_ORDER.indexOf(second.value);
    const firstIsSpecial = firstSpecialIndex !== -1;
    const secondIsSpecial = secondSpecialIndex !== -1;
    if (!firstIsSpecial && !secondIsSpecial)
        return first.value.localeCompare(second.value);
    if (firstIsSpecial && secondIsSpecial)
        return firstSpecialIndex - secondSpecialIndex;
    return firstIsSpecial ? 1 : -1;
});
exports.sortMatrixAttributeValues = sortMatrixAttributeValues;
/** Build the composite key used everywhere in the table */
const getKey = (value, title) => `${value}||${title}`;
exports.getKey = getKey;
/** Reverse of makeKey */
const parseKey = (key) => key.split('||');
exports.parseKey = parseKey;
/** Transform data into grouped options format for selectors */
const createGroupedOptions = (data) => data.map(({ title, id, descendants }) => ({
    label: title,
    value: id,
    children: descendants.edges.map((edge) => ({
        label: edge.node.descendant.title,
        value: edge.node.descendant.id,
    })),
}));
exports.createGroupedOptions = createGroupedOptions;
